<aside class="col-md-12 third__party__consignment mb-4 position-relative">
  <i matTooltip="Cerrar" class="fas fa-times fa-2xl close-icon-actions t-0" (click)="dialogRef.close()"></i>
  <div class="title-component mr-4">
    <div class="col-md-12 mt-4">
      <i class="fas fa-building"></i>
      {{modalTitle}}
    </div>
  </div>
  <div *ngIf="dataDialog?.options?.alertMessage" class="col-12 mb-3 px-0">
    <div class="alert alert-warning">
      <div style="display: flex; align-items: center;">
        <i class="fas fa-exclamation-triangle" style="color: #856404; margin-right: 8px;"></i>
        <span style="color: #856404; font-size: 14px;">{{dataDialog?.options?.alertMessage}}</span>
      </div>
    </div>
  </div>
  <form class="third__party__consignment-form" [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="row">
      <app-autocomplete-city [inputFormControl]="cityControl" class="col-12" [options]="cityOptions"
        [validate]="cityValidate">
      </app-autocomplete-city>
      <!-- Document Type  -->
      <div class="col-md-6" *ngIf="!dataDialog?.options?.thirdParty">
        <mat-form-field appearance="outline">
          <mat-label>Tipo de documento<span class="asterisk">*</span></mat-label>
          <mat-select [formControl]="documentTypeNameControl" [displayWith]="displayDocumentTypeName"
            (selectionChange)="onChangeDocumentType($event)">
            <mat-option *ngFor="let type of global.documenTypes" [value]="type">
              {{type.name}}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="documentTypeNameControl.errors?.required">
            {{ utils.giveMessageError('MANDATORY_FIELD') }}
          </mat-error>
        </mat-form-field>
      </div>
      <!-- Number Document -->
      <div class="col-md-6">
        <mat-form-field appearance="outline" formGroupName="information">
          <mat-label>Número de documento<span class="asterisk">*</span></mat-label>
          <input matInput type="text" onlyNumbersInt name="document" formControlName="document" autocomplete="off">
          <mat-error *ngIf="form.get('information.document').errors?.required">
            {{ utils.giveMessageError('MANDATORY_FIELD') }}
          </mat-error>
          <mat-error *ngIf="form.get('information.document').errors?.minlength">
            {{ utils.giveMessageError('MIN_LENGTH_NOT_REACHED', 'número de documento', minDocument) }}
          </mat-error>
          <mat-error *ngIf="form.get('information.document').errors?.maxlength">
            {{ utils.giveMessageError('MAX_LENGTH_EXCEED', 'número de documento', maxDocument) }}
          </mat-error>
        </mat-form-field>
      </div>
      <!-- Name -->
      <div class="col-12" [ngClass]="{'col-md-6':dataDialog?.options?.thirdParty}">
        <mat-form-field appearance="outline" formGroupName="information">
          <mat-label>Nombre<span class="asterisk">*</span></mat-label>
          <input matInput type="text" name="name" formControlName="name" autocomplete="off">
          <mat-error *ngIf="form.get('information.name').errors?.required">
            {{ utils.giveMessageError('MANDATORY_FIELD') }}
          </mat-error>
        </mat-form-field>
      </div>
      <!-- Address -->
      <app-autocomplete-address class="col-md-6" [options]="addressOptions" [inputFormControl]="addressControl"
        [validate]="validate">
      </app-autocomplete-address>
      <mat-form-field appearance="outline" class="col-md-6">
        <mat-label>Nombre de sede<span class="asterisk">*</span></mat-label>
        <input matInput type="text" name="name" formControlName="branchOfficeName" autocomplete="off">
        <mat-error *ngIf="form.get('branchOfficeName').errors?.required">
          {{ utils.giveMessageError('MANDATORY_FIELD') }}
        </mat-error>
      </mat-form-field>

      <!-- Geo error — above map -->
      <div class="col-12" *ngIf="!form?.get('address')?.pending && form?.get('address')?.errors?.outsideMunicipality as err">
        <div class="geo-error-card mt-2">
          <i class="fas fa-map-marked-alt geo-error-card__icon"></i>
          <div class="geo-error-card__body">
            <strong>
              Dirección fuera de {{ err.municipalityName || 'el municipio seleccionado' }}<ng-container *ngIf="err.departmentName">, {{ err.departmentName }}</ng-container>
            </strong>
            <span>
              <ng-container *ngIf="err.distanceMeters">A {{ err.distanceMeters | number:'1.0-0' }} m del límite · </ng-container>
              Mueve el pin al área azul o cambia la ciudad.
            </span>
          </div>
        </div>
      </div>
      <!-- Map -->
      <div class="col-12 mt-3">
        <div class="map-viewport">
          <app-standard-map [options]="mapOptions" (clickMap)="onClickMap($event)"></app-standard-map>
          <div class="map-chip map-chip--loading" *ngIf="loadingPolygon">
            <i class="fas fa-circle-notch fa-spin"></i> Cargando…
          </div>
          <div class="map-verify-bar" *ngIf="form?.get('address')?.pending">
            <i class="fas fa-circle-notch fa-spin mr-1"></i> Verificando ubicación…
          </div>
        </div>
      </div>
    </div>

    <span class="separator-horizontal"></span>
    <div class="button-container">
      <button mat-raised-button color="primary" type="submit"
              class="button-width-auto bg-color-primary"
              [disabled]="form?.get('address')?.pending || form?.get('address')?.errors?.outsideMunicipality">
        <span *ngIf="form?.get('address')?.pending">
          <i class="fas fa-circle-notch fa-spin mr-1"></i>Verificando…
        </span>
        <span *ngIf="!form?.get('address')?.pending && form?.get('address')?.errors?.outsideMunicipality">
          <i class="fas fa-exclamation-circle mr-1"></i>Dirección inválida
        </span>
        <span *ngIf="!form?.get('address')?.pending && !form?.get('address')?.errors?.outsideMunicipality">
          Guardar
        </span>
      </button>
    </div>
  </form>
</aside>
